













import { Component, Vue, Mixins, Prop, Watch } from 'vue-property-decorator';
import { State } from 'vuex-class';
import FooterMenu from '@/components/FooterMenu.vue';
import UserMixin from '@/mixins/UserMixin';
import Logger, { ILogEntry, LogSeverity } from '@/common/logging/Logger';
import { ILoggingState } from '../store/logging';

interface ILogMessage {
    type: string;
    namespace: string;
    message: string;
}

@Component({
    components: {
        FooterMenu,
    },
})
export default class Debug extends Mixins(UserMixin) {
    @Prop()
    public deviceNumber: string;

    @State('logging')
    public loggingState: ILoggingState;

    private logger = Logger('debugger');

    public get entries(): ILogEntry[] {
        const result: ILogEntry[] = [];
        for (let i = this.loggingState.entries.length - 1; i >= 0; i--) {
            result.push(this.loggingState.entries[i]);
        }
        return result;
    }

    public formatTimestamp(timestamp: Date) {
        const h = timestamp.getHours();
        const m = timestamp.getMinutes();
        const s = timestamp.getSeconds();
        return `${h < 10 ? '0' + h : h}:${m < 10 ? '0' + m : m}:${s < 10 ? '0' + s : s}`;
    }
    public getClass(entry: ILogEntry) {
        return {
            error: entry.severity === LogSeverity.error,
            fatal: entry.severity === LogSeverity.fatal,
            warning: entry.severity === LogSeverity.warning,
            info: entry.severity === LogSeverity.info,
            debug: entry.severity === LogSeverity.debug,
        };
    }

    public created() {
        // setInterval(this.generateMessage, 500);
    }
    private generateMessage() {
        const rnd = Math.random();
        this.logger.debug('Test');
    }

    @Watch('loggingState')
    private loggingStateUpdate() {
        // console.log('logging state');
    }

    private scrollToBottom() {
        // const debug = this.$refs.debug as Element;
        // debug.scrollTop = debug.scrollHeight;
    }
}
